<template>
  <div class="check-install">
    <div class="step-1"
         v-if="!result">
      <div class="step-header">
        <i class="icon icon--document-write"></i>
        <p class="description" v-html="$t('dashboard.checkInstall.request.description')"></p>
      </div>

      <div class="step-body">
        <ui-input-text :type="'text'"
                       :modelValue="url"
                       :modelError="error"
                       :placeholder="'e.g. http://www.example.net/pages/?x=1'"
                       @input="setUrl" />
        <ui-button :disabled="!canConfirm"
                   @click="onConfirm">{{ $t('common.confirm') }}</ui-button>
      </div>

      <button type="button" class="btn-close"
              @click="$emit('onClose')">
        <i class="icon icon--close-btn"></i>
      </button>
    </div>

    <div class="result"
         v-else-if="result === 'success'">
      <i class="icon icon--check-green-size50"></i>
      <p class="title" v-html="$t('dashboard.checkInstall.confirmed.title')"></p>
      <p class="description" v-html="$t('dashboard.checkInstall.confirmed.description')"></p>
      <ui-button class="btn__confirm" @click="$emit('onClose')">
        {{ $t('common.confirm') }}
      </ui-button>
    </div>

    <div class="result"
         v-else>
      <i class="icon icon--alert"></i>
      <p class="title" v-html="$t('dashboard.checkInstall.failed.title')"></p>
      <p class="description">
        <em v-html="$t('dashboard.checkInstall.failed.description1')"></em><br>
        {{ $t('dashboard.checkInstall.failed.description2') }}
      </p>
      <ui-button class="btn__confirm" @click="$emit('onClose')">
        {{ $t('common.confirm') }}
      </ui-button>
    </div>
  </div>
</template>

<script>
import { isValidUrl } from '@/libs/validation-helper'
import { checkInstall } from '@/api/domain'
import UiInputText from '@/components/ui/UiInputText'
import UiButton from '@/components/ui/UiButton'

export default {
  name: 'CheckInstall',
  components: {
    UiInputText,
    UiButton
  },
  props: [
    'sid'
  ],
  watch: {
    result (value) {
      if (value === 'success') {
        this.$emit('onInstallSuccess', true)
      }
    }
  },
  methods: {
    setUrl (value) {
      this.url = value
      this.error = ''
    },
    onConfirm () {
      if (this.url.substr(0, 4) !== 'http') {
        this.url = 'http://' + this.url
      }

      if (!isValidUrl(this.url)) {
        this.error = 'unAbleDomain'
      } else {
        this.error = ''

        checkInstall({
          url: this.url,
          sid: this.sid
        }, true).then(res => {
          if (!res.message) {
            this.result = 'success'
          } else {
            this.result = 'fail'
          }
        }).catch(res => {
          this.result = 'fail'
        })
      }
    }
  },
  computed: {
    canConfirm () {
      return !this.error && this.url.length > 0
    }
  },
  data () {
    return {
      url: '',
      error: '',
      result: null
    }
  }
}
</script>

<style lang="scss" scoped>
.check-install {
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;

  .step-1 {
    padding: 28px 20px;

    .step-header {
      .icon {
        vertical-align: middle;
      }

      .description {
        display: inline-block;
        vertical-align: middle;
        font-size: 14px;
        line-height: 1.43;
        color: #2f2f2f;
        margin-left: 3px;
      }
    }

    .step-body {
      padding: 10px;

      .input--wrap {
        margin-top: -5px;
        width: 480px;
        display: inline-block;

        label {
          display: none;
        }
      }

      .ui-btn {
        margin-left: 5px;
      }
    }
  }

  .result {
    width: 430px;
    text-align: center;

    .icon {
      margin: 50px 50px 15px 50px;
    }

    .title {
      font-size: 20px;
      font-weight: 500;
      color: #444444;
      margin: 0 11px 11px;
      line-height: 1.3;
    }

    .description {
      font-size: 14px;
      line-height: 1.57;
      color: #2f2f2f;

      em {
        color: #fc004e;
      }
    }

    .ui-btn {
      margin: 35px 0 25px;
    }
  }

  .btn-close {
    position: absolute;
    right: 12px;
    top: 12px;
  }
}
</style>
